import React from 'react';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import OpenCsQnaQuestion from '../../../../../containers/cs/qna/common/OpenCsQnaQuestion';
import Button from '../../../../../components/Button';
import Select from '../../../../../components/input/Select';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import OpenUserDetail from '../../../../../components/link/OpenUserDetail';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import Anchor from '../../../../../components/link/Anchor';
import {
  CS_QNA_RESPONSE_STATUS_SELECT_LIST,
  CS_QNA_RESPONSE_STATUS_TEXT,
  CS_QNA_STATUS_SELECT_LIST,
  CS_QNA_STATUS_TEXT,
  ORDER_QNA_TYPE_SELECT_LIST,
  CS_QNA_TODAY_DELIVERY_SELECT_LIST,
} from '../../../../../constants/service/app/csQnaConstants';
import { TODAY_DELIVERY_TYPE_TEXT } from '../../../../../constants/service/common/commonConstants';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import {
  openNewWindow,
  reDirectPage,
  setColumnWidth,
  setDash,
  setDetailPageUrl,
  addAllItemToSelectList,
} from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import { CS_QNA_DETAIL_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import {
  ORDER_ITEM_STATUS_SELECT_LIST,
  ORDER_ITEM_STATUS_TEXT,
} from '../../../../../constants/service/app/orderConstants';
import OpenOrderItemDetail from '../../../../../components/link/OpenOrderItemDetail';

/**
 *  상품 문의 리스트 컬럼
 */
const columns = (data) => {
  const { list, filterOption, onFilter } = data;
  return [
    {
      accessor: 'isResponse',
      Header: '답변 처리',
      filterable: true,
      fixed: 'left',
      width: 100,
      Cell: (row) => (
        <Button
          isRadius
          color={row.value ? 'primary' : 'red'}
          text={CS_QNA_RESPONSE_STATUS_TEXT[row.value]}
          onClick={() => reDirectPage({ path: setDetailPageUrl(CS_QNA_DETAIL_URL_PATH, row.original.id) })}
        />
      ),
      Filter: () => (
        <Select
          list={CS_QNA_RESPONSE_STATUS_SELECT_LIST}
          onChange={(isResponse) => onFilter({ isResponse })}
          defaultValue={filterOption.isResponse}
          value={filterOption.isResponse}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'orderItemId',
      Header: '주문여부',
      filterable: true,
      fixed: 'left',
      width: 100,
      Cell: (row) => (row.value ? <OpenOrderItemDetail text={row.value} orderItemId={row.value} /> : '-'),
      Filter: () => (
        <Select
          list={ORDER_QNA_TYPE_SELECT_LIST}
          onChange={(isOrderQna) => onFilter({ isOrderQna })}
          value={filterOption.isOrderQna}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'orderItemStatus',
      Header: '주문상태',
      filterable: true,
      fixed: 'left',
      width: 100,
      Cell: (row) => ORDER_ITEM_STATUS_TEXT[row.value] || '-',
      Filter: () => (
        <Select
          list={addAllItemToSelectList(ORDER_ITEM_STATUS_SELECT_LIST)}
          onChange={(orderItemStatus) => onFilter({ orderItemStatus })}
          value={filterOption.orderItemStatus}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'id',
      Header: '상품 문의 ID',
      filterable: true,
      fixed: 'left',
      width: 100,
      Cell: (row) => (
        <Anchor
          isUnderLine
          color="primary"
          text={row.value}
          onClick={() => openNewWindow(setDetailPageUrl(CS_QNA_DETAIL_URL_PATH, row.value))}
        />
      ),
      Filter: () => <TableFilterInput option={filterOption.id} onFilter={(id) => onFilter({ id })} />,
    },
    {
      accessor: 'status',
      Header: '상태',
      filterable: true,
      fixed: 'left',
      width: 140,
      Cell: (row) => CS_QNA_STATUS_TEXT[row.value] || '-',
      Filter: () => (
        <Select
          list={CS_QNA_STATUS_SELECT_LIST}
          onChange={(status) => onFilter({ status })}
          defaultValue={filterOption.status}
          value={filterOption.status}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'productId',
      Header: '상품번호(AMONDZ)',
      filterable: true,
      fixed: 'left',
      width: 150,
      Cell: (row) => <OpenProductDetail text={row.value} productId={row.value} />,
      Filter: () => (
        <TableFilterInput option={filterOption.productId} onFilter={(productId) => onFilter({ productId })} />
      ),
    },
    {
      accessor: 'productName',
      Header: '상품명',
      className: 'align-left',
      resizable: true,
      filterable: true,
      fixed: 'left',
      width: 200,
      Cell: (row) => <OpenPreviewProductDetail text={row.value} productId={row.original.productId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.productName} onFilter={(productName) => onFilter({ productName })} />
      ),
    },
    {
      accessor: 'storeName',
      Header: '상점명',
      resizable: true,
      filterable: true,
      width: setColumnWidth(list, 'storeName'),
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.original.storeId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.storeName} onFilter={(storeName) => onFilter({ storeName })} />
      ),
    },
    {
      accessor: 'storeId',
      Header: '브랜드 ID',
      filterable: true,
      width: 70,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.value} />,
      Filter: () => <TableFilterInput option={filterOption.storeId} onFilter={(storeId) => onFilter({ storeId })} />,
    },
    {
      accessor: 'isTodayDelivery',
      Header: '오늘 출발 여부',
      filterable: true,
      width: 120,
      Cell: (row) => TODAY_DELIVERY_TYPE_TEXT[row.value] || '-',
      Filter: () => (
        <Select
          list={CS_QNA_TODAY_DELIVERY_SELECT_LIST}
          onChange={(isTodayDelivery) => onFilter({ isTodayDelivery })}
          defaultValue={filterOption.isTodayDelivery}
          value={filterOption.isTodayDelivery}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'userAccount',
      Header: '문의자 ID',
      resizable: true,
      filterable: true,
      width: setColumnWidth(list, 'userAccount'),
      Cell: (row) => <OpenUserDetail text={row.value} userId={row.original.userId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.userAccount} onFilter={(userAccount) => onFilter({ userAccount })} />
      ),
    },
    {
      accessor: 'userName',
      Header: '문의자명',
      filterable: true,
      width: setColumnWidth(list, 'userName'),
      Filter: () => <TableFilterInput option={filterOption.userName} onFilter={(userName) => onFilter({ userName })} />,
    },
    {
      accessor: 'question',
      Header: '문의내용',
      className: 'align-left',
      resizable: true,
      filterable: true,
      width: 400,
      Cell: (row) => (
        <OpenCsQnaQuestion
          text={row.value}
          question={row.value}
          answer={row.original.answer}
          memo={row.original.memo}
        />
      ),
      Filter: () => <TableFilterInput option={filterOption.question} onFilter={(question) => onFilter({ question })} />,
    },
    {
      accessor: 'answer',
      Header: '답변내용',
      className: 'align-left',
      resizable: true,
      width: 400,
      Cell: (row) => (
        <OpenCsQnaQuestion
          text={row.value}
          question={row.original.question}
          answer={row.value}
          memo={row.original.memo}
        />
      ),
    },
    {
      accessor: 'replyAuthor',
      Header: '답변 작성자',
      filterable: true,
      width: setColumnWidth(list, 'replyAuthor'),
      Cell: (row) => setDash(row.value),
      Filter: () => (
        <TableFilterInput option={filterOption.replyAuthor} onFilter={(replyAuthor) => onFilter({ replyAuthor })} />
      ),
    },
    {
      accessor: 'memo',
      Header: '답변 작성자 메모',
      className: 'align-left',
      filterable: true,
      resizable: true,
      width: 200,
      Cell: (row) => (
        <OpenCsQnaQuestion
          text={row.value}
          question={row.original.question}
          answer={row.original.answer}
          memo={row.value}
        />
      ),
      Filter: () => <TableFilterInput option={filterOption.memo} onFilter={(memo) => onFilter({ memo })} />,
    },
    {
      accessor: 'answerDate',
      Header: '답변 일자',
      sortable: true,
      filterable: true,
      width: 320,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.answerDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(data) => onFilter({ answerDate: data })}
        />
      ),
    },
    {
      accessor: 'createDate',
      Header: '문의 작성 일자',
      sortable: true,
      filterable: true,
      width: 320,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.createDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(data) => onFilter({ createDate: data })}
        />
      ),
    },
  ];
};

export default columns;
